import * as React from 'react';
import {loadModules} from 'esri-loader';
import {serialize} from "../../../utils";

export default class GeoJSONLayer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            geoJSONLayer: null
        };
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules([
            'esri/layers/GeoJSONLayer',
            'esri/geometry/SpatialReference',
            "esri/config"
        ]).then(([GeoJSONLayer, SpatialReference, esriConfig]) => {
            esriConfig.request.timeout = 2400000;
            const spatialReference = new SpatialReference(3301);
            // const envelope = new Extent(40500, 5993000, 1064500, 7017000, {wkid: 3301});
            let url = (this.props.url ? this.props.url : ''),
                params = {};

            if (localStorage.getItem('user_token')) {
                params.bearer = localStorage.getItem('user_token');
            }
            if (this.props.urlParams) {
                Object.keys(this.props.urlParams).forEach(key =>
                    params[key] = this.props.urlParams[key]
                );
            }
            if (Object.keys(params).length > 0) {
                let queryString = serialize(params);
                url += '?' + queryString;
            }

            if (this.props.params) {
                url += '&' + this.props.params;
            }

            const urlCountOnly = url + (url.slice(-8) === '.geojson' ? '?' : '') + '&countOnly=true';

            let that = this;

            //Check before load GeoJSONLayer data (if no data -> GeoJSONLayer will throw error and ruin all map logic)
            fetch(urlCountOnly)
                .then(function(response) {
                    return response.json();
                }).then(function(data) {
                    if(data.count > 0 || data.features){
                        if(typeof that.props.returnCount === 'function'){
                            that.props.returnCount(data);
                        }

                        let geoJSONLayer = new GeoJSONLayer({
                            url: url,
                            title: that.props.title ? that.props.title : '',
                            id: that.props.id,
                            visible: (that.props.visible !== undefined) ? that.props.visible : true,
                            opacity: that.props.opacity,
                            popupEnabled: that.props.popupEnabled !== false,
                            legendEnabled: true,
                            objectIdField: 'id',
                            popupTemplate: that.props.popupTemplate ? that.props.popupTemplate : '',
                            spatialReference: spatialReference,
                            index: that.props.index,
                            outFields: ["*"]
                        });

                        if (that.props.renderer) {
                            geoJSONLayer.renderer = that.props.renderer
                        }

                        if (that.props.index !== undefined) {
                            that.props.map.add(geoJSONLayer, that.props.index);
                        } else {
                            that.props.map.add(geoJSONLayer);
                        }

                        that.setState({geoJSONLayer});
                    }
                });

        }).catch((err) => {
            if(typeof this.props.onError === 'function'){
                this.props.onError();
            }
            console.error(err)
        });
    }

    componentWillUnmount() {
        this.props.map.remove(this.state.geoJSONLayer);
    }
}
